import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material'
import theme from './themes/mui-theme'
import App from './App'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { envConstants } from './constants/app-constants'

const queryClient = new QueryClient({
  /* Defaults set here apply globally */
  defaultOptions: {
    /* TODO:  Temporarily disabling to determine which
              default behaviors the app can benefit from */
    queries: {
      retry: false,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: true,
    },
  },
})

const isDevelopment = import.meta.env.MODE === envConstants.DEVELOPMENT

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
      {isDevelopment && (
        <ReactQueryDevtools initialIsOpen={false} position="right" buttonPosition="bottom-right" />
      )}
    </QueryClientProvider>
  </React.StrictMode>,
)
